import {
  UPDATE_TENANT_SETTINGS,
  UPDATE_TENANT_SETTINGS_SUCCESS,
  UPDATE_TENANT_SETTINGS_ERROR,
  RESET_TENANT_SETTINGS_STATUS,
  RESET_TENANT_SETTINGS_ERROR,
  GET_TENANT_SETTINGS,
  GET_TENANT_SETTINGS_SUCCESS,
  GET_TENANT_SETTINGS_ERROR,
} from "./actionTypes";

const initialState = {
  status: null,
  error: null,
  settings: null,
};

const TenantSettings = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TENANT_SETTINGS:
      state = {
        ...state,
        status: "loading",
        error: null,
      };
      break;

    case UPDATE_TENANT_SETTINGS_SUCCESS:
      state = {
        ...state,
        status: "success",
        error: null,
      };
      break;

    case UPDATE_TENANT_SETTINGS_ERROR:
      state = {
        ...state,
        status: "error",
        error: action.payload,
      };
      break;

    case GET_TENANT_SETTINGS:
      state = {
        ...state,
        status: "loading",
        error: null,
      };
      break;

    case GET_TENANT_SETTINGS_SUCCESS:
      state = {
        ...state,
        status: null,
        settings: action.payload,
        error: null,
      };
      break;

    case GET_TENANT_SETTINGS_ERROR:
      state = {
        ...state,
        status: "error",
        error: action.payload,
        settings: null,
      };
      break;

    case RESET_TENANT_SETTINGS_STATUS:
      state = {
        ...state,
        status: null,
      };
      break;

    case RESET_TENANT_SETTINGS_ERROR:
      state = {
        ...state,
        error: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default TenantSettings;
